import type { Address, ChainId } from '@morpho-org/blue-sdk'

import { isAddressEqual } from 'viem'
import { mainnet } from 'viem/chains'

type DonationVaults = {
  [chainId in ChainId]?: Address[]
}

/**
 * Vaults whose yield includes donations paid in the vault's underlying asset.
 *
 * The frontend can only auto-detect that a vault is rate-capped (`maxRate`),
 * not *why* the yield is boosted — so donation-boosted vaults are tagged
 * manually here until the API exposes a proper donation signal (Phase 2).
 *
 * Tagged vaults get the rewards sparkle next to their Net APY and the
 * "Donations" label for a positive surplus-boost row.
 */
export const DONATION_VAULTS: DonationVaults = {
  [mainnet.id]: [
    '0xbeef0C075Da5D01112AE5cF34d257074fB5DDB2f', // Steakhouse Prime EURCV
    '0xbEEF00A59B577423653A1526c7009bdE103F542B' // Steakhouse Confidential Prime USDC
  ]
}

export function vaultIncludesDonations(
  chainId: ChainId | undefined,
  vaultAddress: Address
): boolean {
  if (!chainId) return false

  const donationVaults = DONATION_VAULTS[chainId]
  if (!donationVaults) return false

  return donationVaults.some(address => isAddressEqual(address, vaultAddress))
}
